/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ finished: NonNullable<unknown>, members: NonNullable<unknown> }} Clubs_Group_FinishedInputs */

const en_us2_clubs_group_finished = /** @type {(inputs: Clubs_Group_FinishedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Reached the goal: ${i?.finished} of ${i?.members}`)
};

const pt_br2_clubs_group_finished = /** @type {(inputs: Clubs_Group_FinishedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bateram a meta: ${i?.finished} de ${i?.members}`)
};

const es_419_clubs_group_finished = /** @type {(inputs: Clubs_Group_FinishedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Alcanzaron la meta: ${i?.finished} de ${i?.members}`)
};

const pt_pt2_clubs_group_finished = /** @type {(inputs: Clubs_Group_FinishedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Atingiram o objetivo: ${i?.finished} de ${i?.members}`)
};

const fr_fr2_clubs_group_finished = /** @type {(inputs: Clubs_Group_FinishedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Objectif atteint : ${i?.finished} sur ${i?.members}`)
};

const de_de2_clubs_group_finished = /** @type {(inputs: Clubs_Group_FinishedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ziel erreicht: ${i?.finished} von ${i?.members}`)
};

const it_it2_clubs_group_finished = /** @type {(inputs: Clubs_Group_FinishedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Obiettivo raggiunto: ${i?.finished} su ${i?.members}`)
};

/**
* | output |
* | --- |
* | "Reached the goal: {finished} of {members}" |
*
* @param {Clubs_Group_FinishedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_group_finished = /** @type {((inputs: Clubs_Group_FinishedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Group_FinishedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_group_finished(inputs)
	if (locale === "es-419") return es_419_clubs_group_finished(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_group_finished(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_group_finished(inputs)
	if (locale === "de-DE") return de_de2_clubs_group_finished(inputs)
	if (locale === "it-IT") return it_it2_clubs_group_finished(inputs)
	return en_us2_clubs_group_finished(inputs)
});
export { clubs_group_finished as "clubs.group_finished" }